import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as r, useEffect as s } from "react";

var u = function u() {
  var _r = r(!1),
      _r2 = _slicedToArray(_r, 2),
      e = _r2[0],
      o = _r2[1];

  return s(function () {
    var t = function t() {
      o(!0);
    };

    return window.addEventListener("touchstart", t, {
      once: !0,
      passive: !0
    }), function () {
      window.removeEventListener("touchstart", t);
    };
  }, []), e;
};

export { u as useTouch };